// // based on https://vueuse.org/core/usePointer/#usepointer
//  MIT License
import { extract, isBrowser, isNullish } from '@vpap_svelte/internal';
import { on } from 'svelte/events';
export default function usePointer(options) {
    let windowTarget = isBrowser() ? window : undefined;
    let element = $derived(extract(options?.target, windowTarget));
    let isInside = $state(false);
    let current = $state(undefined);
    let pointerTypes = options?.pointerTypes ?? ['mouse', 'pen', 'touch'];
    const handler = (evt) => {
        isInside = true;
        const event = evt;
        // this just gets around a typing mismatch where Svelte's `on` treats the event handler as a generic (e: Event) => void
        // function
        if (pointerTypes.includes(event.pointerType)) {
            current = event;
        }
    };
    $effect(() => {
        if (isNullish(element))
            return;
        const pointerleave = on(element, 'pointerleave', () => (isInside = false));
        const pointerdown = on(element, 'pointerdown', handler, { passive: true });
        const pointermove = on(element, 'pointermove', handler, { passive: true });
        const pointerup = on(element, 'pointerup', handler, { passive: true });
        return () => {
            pointerleave();
            pointerdown();
            pointermove();
            pointerup();
        };
    });
    return {
        /**
         * The most recent pointer event
         */
        get current() {
            return current;
        },
        /**
         * The offset from the most current pointer event in pixel coordinates
         */
        get offset() {
            if (!isBrowser() || isNullish(element) || current === undefined)
                return undefined;
            if (element === window || element === document) {
                return [current.x, current.y];
            }
            const bbox = element.getBoundingClientRect();
            return [current.x - bbox.left, current.y - bbox.top];
        },
        get isInside() {
            return isInside;
        },
    };
}
